import { motion } from "framer-motion";
import { PLATFORM_PRINCIPLES } from "@/data/content";

export const ProductsIntro = () => (
  <section data-testid="products-intro-section" className="bg-baseLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-16"
      >
        <div className="lg:col-span-5">
          <h2
            data-testid="products-intro-headline"
            className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
          >
            Built as a platform. Configured for the site
          </h2>
        </div>
        <p data-testid="products-intro-text" className="text-[15px] leading-relaxed text-inkSoft lg:col-span-7 lg:pt-1">
          Off-Grid Hydrogen uses a repeatable hybrid system architecture while configuring
          <br className="hidden lg:block" /> generation, storage and critical-load requirements around each operation.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        data-testid="products-principles-row"
        className="mt-14 grid grid-cols-1 divide-y divide-borderLight border-t border-borderLight sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:mt-16 lg:grid-cols-4"
      >
        {PLATFORM_PRINCIPLES.map((principle, i) => (
          <div key={principle} data-testid={`products-principle-${i}`} className="py-6 sm:px-6 sm:py-8 lg:px-8">
            {principle === "Standardized EMS & communications" ? (
              <span className="text-base font-medium leading-snug text-ink lg:text-lg">
                Standardized EMS<br className="hidden lg:block" /> &amp; communications
              </span>
            ) : (
              <span className="text-base font-medium leading-snug text-ink lg:text-lg">{principle}</span>
            )}
          </div>
        ))}
      </motion.div>
    </div>
  </section>
);
